<template>
  <v-row
    justify="center"
    align="center"
    v-if="split_sender"
    id="StplitStatus_graphs"
  >
    <v-col lg="4" cols="12" sm="8">
      <v-row justify="center" align="center">
        <v-col cols="12" class="text-center" v-if="model">
          <v-chip class="ma-3" label>
            <h4>
              {{
                `${$t(
                  "analytics.conversations.conversations_split_status.graph_elements.select.selected_type"
                )} : ${items.find((x) => x.value == model).text}`
              }}
            </h4>
          </v-chip>
        </v-col>
        <v-col cols="12">
          <v-select
            v-model="model"
            :items="items"
            :label="
              $t(
                'analytics.conversations.conversations_split_status.graph_elements.select.label'
              )
            "
            outlined
            clearable
            :hint="
              $t(
                'analytics.conversations.conversations_split_status.graph_elements.select.hint'
              )
            "
            persistent-hint
            @change="Onchange"
            @click:clear="clear"
            :disabled="!dataSource.series[0].data.length"
            :menu-props="{ bottom: true, offsetY: true }"
          ></v-select>
        </v-col>
      </v-row>
    </v-col>
    <v-col lg="12" cols="12" sm="12">
      <v-card flat :loading="loading">
        <template v-slot:progress>
          <v-row class="fill-height" align-content="center" justify="center">
            <v-col cols="6">
              <v-progress-linear
                color="deep-purple darken-4"
                indeterminate
                rounded
                height="6"
              ></v-progress-linear>
            </v-col>
          </v-row>
        </template>
        <div v-if="!model && !loading">
          <MixedCarts
            :dataSource="dataSource"
            v-if="dataSource.series[0].data.length"
          />
        </div>
        <div v-if="model && !loading">
          <MixedCarts :dataSource="dataSource1" />
        </div>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import MixedCarts from "../charts/ApexCartsMixed.vue";
export default {
  name: "StplitStatus",
  components: {
    MixedCarts,
  },
  data() {
    return {
      loading: false,
      model: "",
      items: [
        { text: "Bot only", value: "only_bot" },
        { text: "Admin only", value: "only_admin" },
        { text: "Mixed", value: "mixed" },
      ],
      monthNames: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
      total_conv: 0,
      dataSource: {
        height: 350,
        type: "bar",
        series: [],
        chartOptions: {
          title: {
            text: "Conversations count",
          },
          chart: {
            type: "bar",
            height: 350,
            stacked: true,
            toolbar: {
              show: true,
            },
            zoom: {
              enabled: true,
            },
          },
          responsive: [
            {
              breakpoint: 480,
              options: {
                legend: {
                  position: "bottom",
                  offsetX: -10,
                  offsetY: 0,
                },
              },
            },
          ],
          plotOptions: {
            bar: {
              horizontal: false,
              borderRadius: 10,
              dataLabels: {
                total: {
                  enabled: true,
                  style: {
                    fontSize: "13px",
                    fontWeight: 900,
                  },
                },
              },
            },
          },
          xaxis: {
            type: "category",
            categories: [],
          },
          legend: {
            position: "right",
            offsetY: 40,
          },
          fill: {
            opacity: 1,
          },
        },
      },
      dataSource1: {
        height: 350,
        type: "bar",
        series: [],
        chartOptions: {
          chart: {
            type: "bar",
            height: 350,
            stacked: true,
          },
          plotOptions: {
            bar: {
              horizontal: true,
              borderRadius: 0,
              borderRadiusApplication: "around",
              borderRadiusWhenStacked: "last",
              columnWidth: "98%",
              barHeight: "95%",
              dataLabels: {
                total: {
                  enabled: true,
                  offsetX: 0,
                  style: {
                    fontSize: "13px",
                    fontWeight: 900,
                  },
                },
              },
            },
          },
          stroke: {
            width: 1,
            colors: ["#fff"],
          },
          title: {
            text: "Split status",
          },
          xaxis: {
            categories: [],
          },
          yaxis: {
            title: {
              text: undefined,
            },
          },
          fill: {
            opacity: 1,
          },
          legend: {
            position: "top",
            horizontalAlign: "left",
            offsetX: 40,
          },
        },
      },
    };
  },
  computed: {
    split_sender() {
      const data = this.$store.state.analytics.SplitSender;
      return data;
    },
  },
  async created() {
    this.loading = true;
    if (this.split_sender?.data.length) {
      await this.init_vals();
    }
    this.loading = false;
  },
  methods: {
    init_vals() {
      this.dataSource.chartOptions.xaxis.categories = [];
      let dataArray = {
        nb_mixed: { data: [], name: "nb_mixed" },
        nb_only_admin: { data: [], name: "nb_only_admin" },
        nb_only_bot: { data: [], name: "nb_only_bot" },
        no_answer: { data: [], name: "no_answer" },
      };
      for (let index = 0; index < this.split_sender.data.length; index++) {
        const element = this.split_sender.data[index];
        dataArray.nb_only_admin.data.push(element.nb_only_admin);
        dataArray.nb_only_bot.data.push(element.nb_only_bot);
        dataArray.no_answer.data.push(element.no_answer);
        dataArray.nb_mixed.data.push(element.nb_mixed);
        this.dataSource.chartOptions.xaxis.categories.push(
          `${this.monthNames[element.month - 1]} - ${element.year}`
        );
      }
      this.dataSource.series = Object.values(dataArray);
    },
    async clear() {
      this.loading = true;
      if (this.split_sender?.data.length) {
        await this.init_vals();
      }
      this.loading = false;
    },
    Onchange() {
      console.log(this.model);
      if (this.model) {
        this.loading = true;
        this.$store
          .dispatch("FETCH_SPLIT_STATUS", {
            dates: this.split_sender.dates,
            conversation_maker: this.model,
          })
          .then(async (r) => {
            if (r.error) {
              console.log(r);
              this.loading = false;
              this.model = null;
              this.$store.dispatch("setSnackbar", {
                text: `No data`,
                color: "error",
                timeout: 2000,
              });
            } else {
              const title = this.items.find((x) => x.value == this.model);
              this.dataSource1.chartOptions.title.text = `${title?.text} split status`;
              await this.change_vals(r.data);
              this.loading = false;
              this.scrollToElement();
            }
          })
          .catch((err) => {
            console.log(err);
            this.loading = false;
            this.model = null;
            this.$store.dispatch("setSnackbar", {
              text: err,
              color: "error",
              timeout: 2000,
            });
          });
      }
    },
    async change_vals(data) {
      let dataArray = {};
      let avilableStatus = [];
      this.dataSource1.chartOptions.xaxis.categories = [];
      let currStatus = [];
      if (data) {
        for (let index = 0; index < data.length; index++) {
          const element = data[index];
          element.status.forEach((st) => {
            avilableStatus.push(st.name);
            dataArray[st.name] = { name: st.name, data: [] };
          });
        }

        for (let index = 0; index < data.length; index++) {
          const element = data[index];
          element.status.map((st) => {
            currStatus.push(st.name);
            dataArray[st.name].data.push(st.number_of_conversations);
          });

          avilableStatus.map((el) => {
            if (!currStatus.includes(el)) {
              dataArray[el].data.push(0);
            }
          });

          this.dataSource1.chartOptions.xaxis.categories.push(
            `${this.monthNames[element.month - 1]} - ${element.year}`
          );
        }
        this.dataSource1.series = Object.values(dataArray);
      }
    },
    scrollToElement() {
      this.$vuetify.goTo("#StplitStatus_graphs", {
        duration: 1300,
        offset: 100,
        easing: "easeInOutCubic",
      });
    },
  },
};
</script>
